"use client";

import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const Sequence = createContext({ phase: "idle", setPhase: () => {} });
export default function PortfolioSequence({ children }) {
  const [phase, setPhase] = useState("idle");
  return <Sequence.Provider value={{ phase, setPhase }}>{children}</Sequence.Provider>;
}
export const usePortfolioSequence = () => useContext(Sequence);

export function usePortfolioEntrance(ref) {
  const visible = useInView(ref, { amount: 0.2 });
  const onScreen = useInView(ref, { amount: "some" });
  const replayArmed = useRef(false);
  const { phase, setPhase } = usePortfolioSequence();
  useEffect(() => {
    // Only re-arm after the deck fully leaves view, avoiding edge-scroll jitter.
    if (!onScreen) replayArmed.current = true;
    if (!visible) return;
    if (phase === "ready") setPhase("cards");
    else if (replayArmed.current && phase === "done") setPhase("stars");
    replayArmed.current = false;
  }, [visible, onScreen, phase, setPhase]);
  return {
    entered: ["cards", "stars", "done"].includes(phase),
    finishEntrance: () => setPhase(current => current === "cards" ? "stars" : current),
  };
}
